import React, { cloneElement, isValidElement, memo } from 'react'

export const ToggleOverlayBtn = memo(props => {
  const { onClick, children } = props || {}
  return isValidElement(children) ? (
    cloneElement(children, {
      onClick: onClick,
      ...children.props,
    })
  ) : !!children ? (
    <span className="inline-flex items-center" onClick={onClick}>
      {children}
    </span>
  ) : null
})
